module.exports = __webpack_public_path__ + "img/import.ba89bac1.svg";